<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'LayoutFullscreen',
})
</script>
<template>
	<SqtSvg
		class="layout-header__tool"
		:name="isFullscreen ? 'unfull-screen' : 'full-screen'"
		@click="toggleFullscreen"
	/>
</template>
<script lang="ts" setup name="LayoutFullscreen">
import { SqtSvg } from '@sqt/ui/es/components/svg'
import { useWebFullscreen } from '../utils/webFullscreen'
const { isFullscreen, toggleFullscreen } = useWebFullscreen()
</script>
